webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(25);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(95);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueWaypoint = __webpack_require__(117);
	
	var _vueWaypoint2 = _interopRequireDefault(_vueWaypoint);
	
	var _vueScrollto = __webpack_require__(116);
	
	var _vueScrollto2 = _interopRequireDefault(_vueScrollto);
	
	var _vueLazyload = __webpack_require__(94);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	__webpack_require__(33);
	
	__webpack_require__(26);
	
	__webpack_require__(32);
	
	__webpack_require__(27);
	
	__webpack_require__(30);
	
	__webpack_require__(34);
	
	__webpack_require__(29);
	
	__webpack_require__(35);
	
	__webpack_require__(31);
	
	__webpack_require__(28);
	
	__webpack_require__(37);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(81);
	
	var Icon = __webpack_require__(1);
	
	_vue2.default.component('icon', Icon);
	_vue2.default.component('lazy-component', _vueLazyload2.default);
	_vue2.default.use(_vueLazyload2.default, {
	  lazyComponent: true,
	  loading: './static/loading.svg'
	});
	_vue2.default.use(_vueScrollto2.default);
	_vue2.default.use(_vueWaypoint2.default);
	
	
	var root = new _vue2.default({
	  render: function render(h) {
	    return h(_App2.default);
	  },
	  data: {
	    ticking: false,
	    particle: null
	  },
	  mounted: function mounted() {
	
	    var isMobileD = {
	      android: function android() {
	        return navigator.userAgent.match(/Android/i);
	      },
	      blackberry: function blackberry() {
	        return navigator.userAgent.match(/BlackBerry/i);
	      },
	      ios: function ios() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	      },
	      opera: function opera() {
	        return navigator.userAgent.match(/Opera Mini/i);
	      },
	      windows: function windows() {
	        return navigator.userAgent.match(/IEMobile/i);
	      },
	      any: function any() {
	        return isMobileD.android() || isMobileD.blackberry() || isMobileD.ios() || isMobileD.opera() || isMobileD.windows();
	      }
	    };
	    isMobileD.any() ? document.body.classList.add('is-touch') : null;
	    var refdiv = document.createElement('div');
	    refdiv.classList.add('bmv-reflection');
	    document.querySelector('.bmv-reflection-container').appendChild(refdiv);
	    document.querySelector('.bmv-reflection').innerHTML = this.sanitize(document.querySelector('.bmv-reflective').innerHTML);
	    window.addEventListener('touchMove', this.requestTick);
	    window.addEventListener('touchStart', this.requestTick);
	    window.addEventListener('touchEnd', this.requestTick);
	    window.addEventListener('scroll', this.requestTick);
	    window.addEventListener('resize', this.requestTick);
	    window.addEventListener('load', this.bmvUpdateReflection);
	  },
	
	  methods: {
	    requestTick: function requestTick() {
	      requestAnimationFrame(this.scrollEvents);
	    },
	    sanitize: function sanitize(html) {
	      return html.replace('id="', 'id="reflected_');
	    },
	    scrollEvents: function scrollEvents() {
	      this.bmvUpdateReflection();
	    },
	    bmvUpdateReflection: function bmvUpdateReflection() {
	      try {
	        var bmvc = document.querySelector('.bmv-reflection-container');
	        var wiggleroom2 = (parseInt(window.getComputedStyle(document.querySelector('.bmv-reflection')).height) - Math.max(document.documentElement.clientHeight, window.innerHeight || 0) + parseInt(window.getComputedStyle(document.querySelector('.bmv-reflection-container')).height)) * -1;
	        if (bmvc.classList.contains('top')) {
	          wiggleroom2 = parseInt(window.getComputedStyle(bmvc).height) * 2 - parseInt(window.getComputedStyle(document.querySelector('.bmv-reflection')).height);
	        }
	        var scrollOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	        document.querySelector('.bmv-reflection').style.marginTop = wiggleroom2 + scrollOffset + 'px';
	      } catch (err) {
	        console.log("Reflection error: " + err.message);
	      }
	    }
	  }
	});
	document.addEventListener('DOMContentLoaded', function () {
	  root.$mount('#app');
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(92)
	
	/* script */
	__vue_exports__ = __webpack_require__(38)
	
	/* template */
	var __vue_template__ = __webpack_require__(115)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(25);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var icons = {};
	
	exports.default = {
	  name: 'icon',
	  props: {
	    name: {
	      type: String,
	      validator: function validator(val) {
	        if (val) {
	          if (!(val in icons)) {
	            _vue2.default.util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
	            return false;
	          }
	          return true;
	        }
	        return null;
	      }
	    },
	    scale: [Number, String],
	    spin: Boolean,
	    inverse: Boolean,
	    flip: {
	      validator: function validator(val) {
	        return val === 'horizontal' || val === 'vertical';
	      }
	    },
	    label: String
	  },
	  data: function data() {
	    return {
	      x: false,
	      y: false,
	      childrenWidth: 0,
	      childrenHeight: 0,
	      outerScale: 1
	    };
	  },
	
	  computed: {
	    normalizedScale: function normalizedScale() {
	      var scale = this.scale;
	      scale = typeof scale === 'undefined' ? 1 : Number(scale);
	      if (isNaN(scale) || scale <= 0) {
	        _vue2.default.util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
	        return this.outerScale;
	      }
	      return scale * this.outerScale;
	    },
	    clazz: function clazz() {
	      return {
	        'fa-icon': true,
	        'fa-spin': this.spin,
	        'fa-flip-horizontal': this.flip === 'horizontal',
	        'fa-flip-vertical': this.flip === 'vertical',
	        'fa-inverse': this.inverse
	      };
	    },
	    icon: function icon() {
	      if (this.name) {
	        return icons[this.name];
	      }
	      return null;
	    },
	    box: function box() {
	      if (this.icon) {
	        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
	      }
	      return '0 0 ' + this.width + ' ' + this.height;
	    },
	    ratio: function ratio() {
	      if (!this.icon) {
	        return 1;
	      }
	      var _icon = this.icon,
	          width = _icon.width,
	          height = _icon.height;
	
	      return Math.max(width, height) / 16;
	    },
	    width: function width() {
	      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
	    },
	    height: function height() {
	      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
	    },
	    style: function style() {
	      if (this.normalizedScale === 1) {
	        return false;
	      }
	      return {
	        fontSize: this.normalizedScale + 'em'
	      };
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.icon) {
	      return;
	    }
	    this.$children.forEach(function (child) {
	      child.outerScale = _this.normalizedScale;
	    });
	    var width = 0;
	    var height = 0;
	    this.$children.forEach(function (child) {
	      width = Math.max(width, child.width);
	      height = Math.max(height, child.height);
	    });
	    this.childrenWidth = width;
	    this.childrenHeight = height;
	    this.$children.forEach(function (child) {
	      child.x = (width - child.width) / 2;
	      child.y = (height - child.height) / 2;
	    });
	  },
	  register: function register(data) {
	    for (var name in data) {
	      var icon = data[name];
	
	      if (!icon.paths) {
	        icon.paths = [];
	      }
	      if (icon.d) {
	        icon.paths.push({ d: icon.d });
	      }
	
	      if (!icon.polygons) {
	        icon.polygons = [];
	      }
	      if (icon.points) {
	        icon.polygons.push({ points: icon.points });
	      }
	
	      icons[name] = icon;
	    }
	  },
	
	  icons: icons
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(49);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _Bubbles = __webpack_require__(97);
	
	var _Bubbles2 = _interopRequireDefault(_Bubbles);
	
	var _Chart = __webpack_require__(98);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Client = __webpack_require__(99);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _About = __webpack_require__(96);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Contact = __webpack_require__(100);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Gallery = __webpack_require__(102);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    bmvBarChart: _Chart2.default,
	    bubbles: _Bubbles2.default,
	    clientlist: _Client2.default,
	    about: _About2.default,
	    gallery: _Gallery2.default,
	    contact: _Contact2.default
	  },
	  data: function data() {
	    return {
	      start: 0,
	      change: 0,
	      increment: 20,
	      elapsedTime: 0,
	      scrollElement: document.body,
	      duration: 750,
	      segments: [{
	        'el': '.home',
	        'link': '.homelink'
	      }, {
	        'el': '.about',
	        'link': '.aboutlink'
	      }, {
	        'el': '.clients',
	        'link': '.clientslink'
	      }, {
	        'el': '.results',
	        'link': '.resultslink'
	      }, {
	        'el': '.gallery',
	        'link': '.gallerylink'
	      }, {
	        'el': '.contact',
	        'link': '.contactlink'
	      }]
	    };
	  },
	  methods: {
	    requestTick: function requestTick() {
	      requestAnimationFrame(this.scrollEvents);
	    },
	    scrollEvents: function scrollEvents() {
	      var spot = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.segments), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var seg = _step.value;
	
	          if (spot > seg.start && spot < seg.end) {
	            var link = document.querySelector(seg.link);
	            link.classList.add('active');
	          } else {
	            document.querySelector(seg.link).classList.remove('active');
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    },
	    setupSegments: function setupSegments() {
	      var _this = this;
	
	      setTimeout(function () {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(_this.segments), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var seg = _step2.value;
	
	            var rect = document.querySelector(seg.el).getBoundingClientRect();
	            var top = rect.top + window.pageYOffset - Math.max(document.documentElement.clientHeight, window.innerHeight || 0) / 3;
	            seg.start = Math.max(top, -1);
	            seg.end = top + rect.height;
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }, 60);
	    }
	  },
	  mounted: function mounted() {
	    this.requestTick();
	    window.addEventListener('load', this.setupSegments);
	    window.addEventListener('scroll', this.requestTick);
	    window.addEventListener('resize', this.requestTick);
	  }
	};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'about'
	};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var enabled = true;
	
	exports.default = {
	  name: 'bubbles',
	  data: function data() {
	    return {
	      colors: ['255,0,0', '0,255,0', '0,0,255'],
	      parts: [],
	      opacity: 0.15,
	      minSpeed: 15,
	      maxSpeed: 30,
	      numParticles: 20,
	      radius: 5,
	      particles: [],
	      canvas: null,
	      canvas2: null,
	      ctx: null,
	      ctx2: null,
	      mouseX: 0,
	      mouseY: 0,
	      repelDist: 0,
	      repelBuffer: 10
	    };
	  },
	  methods: {
	    createParticleTemplates: function createParticleTemplates() {
	      for (var n = 0; n < this.colors.length; n++) {
	        var tmpCanvas = document.createElement('canvas');
	        tmpCanvas.width = this.radius * 2;
	        tmpCanvas.height = this.radius * 2;
	        var tmpctx = tmpCanvas.getContext('2d');
	        var grd = tmpctx.createRadialGradient(this.radius + Math.random() / 10, this.radius, this.radius, this.radius, this.radius, this.radius / 1.25);
	        grd.addColorStop(0, 'rgba(' + this.colors[n] + ', 0)');
	        grd.addColorStop(1, 'rgba(' + this.colors[n] + ', ' + this.opacity + ')');
	        tmpctx.fillStyle = grd;
	        tmpctx.fillRect(0, 0, this.radius * 2, this.radius * 2);
	        this.parts[n] = tmpCanvas;
	      }
	    },
	    drawParticles: function drawParticles() {
	      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
	      this.ctx.fillStyle = "white";
	      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
	      for (var n = 0; n < this.numParticles; n++) {
	        this.moveParticle(this.particles[n]);
	        this.ctx.drawImage(this.particles[n].drawn, this.particles[n].xPos, this.particles[n].yPos);
	      }
	      this.ctx2.clearRect(0, 0, this.canvas2.width, this.canvas2.height);
	      this.ctx2.fillStyle = "white";
	      this.ctx2.fillRect(0, 0, this.canvas2.width, this.canvas2.height);
	      this.ctx2.drawImage(this.canvas, 0, 0);
	    },
	    resetParticle: function resetParticle(particle) {
	      var size = this.radius;
	      this.changeParticleColor(particle);
	      var neg = 1;
	      var neg2 = 2;
	      if (this.rand(0, 1) > .5) neg = -1;
	      if (this.rand(0, 1) > .5) neg2 = -2;
	      particle.xVel = this.rand(this.minSpeed, this.maxSpeed) * neg;
	      particle.yVel = this.rand(this.minSpeed, this.maxSpeed) * neg2;
	      if (particle.xVel > 0) {
	        if (particle.yVel > 0) {
	          if (particle.xVel > particle.yVel) {
	            particle.xPos = 0 - 2 * size;
	            particle.yPos = this.rand(0, this.canvas.height) - size;
	          } else {
	            particle.yPos = 0 - 2 * size;
	            particle.xPos = this.rand(0, this.canvas.width) - size;
	          }
	        } else {
	          if (particle.xVel > -particle.yVel) {
	            particle.xPos = 0 - 2 * size;
	            particle.yPos = this.rand(0, this.canvas.height) - size;
	          } else {
	            particle.yPos = this.canvas.height;
	            particle.xPos = this.rand(0, this.canvas.width) - size;
	          }
	        }
	      } else {
	        if (particle.yVel > 0) {
	          if (-particle.xVel > particle.yVel) {
	            particle.xPos = this.canvas.width;
	            particle.yPos = this.rand(0, this.canvas.height) - size;
	          } else {
	            particle.xPos = this.rand(0, this.canvas.width) - size;
	            particle.yPos = 0 - 2 * size;
	          }
	        } else {
	          if (-particle.xVel > -particle.yVel) {
	            particle.xPos = this.canvas.width;
	            particle.yPos = this.rand(0, this.canvas.height) - size;
	          } else {
	            particle.yPos = this.canvas.height;
	            particle.xPos = this.rand(0, this.canvas.width) - size;
	          }
	        }
	      }
	    },
	    distanceBetween: function distanceBetween(x1, y1, x2, y2) {
	      return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
	    },
	    moveParticle: function moveParticle(particle) {
	      var dist = this.distanceBetween(particle.xPos + particle.radius, particle.yPos + particle.radius, this.mouseX, this.mouseY);
	
	      if (dist <= this.repelDist + this.repelBuffer) {
	        var x = particle.xPos + particle.radius;
	        var y = particle.yPos + particle.radius;
	        var dx = x - this.mouseX;
	        var dy = y - this.mouseY;
	        var moveDist = this.distanceBetween(0, 0, particle.xVel, particle.yVel);
	        var newx = Math.sqrt(moveDist / (dy / dx * (dy / dx) + 1));
	        var newy = Math.sqrt(moveDist / (dx / dy * (dx / dy) + 1));
	        if (dx < 0) newx = 0 - newx;
	        if (dy < 0) newy = 0 - newy;
	        var multiVel = (dist - this.repelDist) / (2 * this.repelBuffer) + 0.5;
	        var multiPush = 1 - multiVel;
	        if (multiVel > 1) {
	          multiVel = 1;
	          multiPush = 0;
	        } else if (multiVel < 0) {
	          multiVel = 0;
	          multiPush = (dist - this.repelDist) / (-2 * this.repelBuffer) + 0.5;
	        }
	        particle.xPos = particle.xPos + multiPush * newx + multiVel * particle.xVel;
	        particle.yPos = particle.yPos + multiPush * newx + multiVel * particle.yVel;
	      } else {
	        particle.xPos += particle.xVel;
	        particle.yPos += particle.yVel;
	      }
	      if (particle.xPos > this.canvas.width || particle.yPos > this.canvas.height || particle.xPos < -2 * particle.radius || particle.yPos < -2 * particle.radius) {
	        this.resetParticle(particle);
	      }
	    },
	    changeParticleColor: function changeParticleColor(particle) {
	      particle.drawn = this.parts[Math.floor(Math.random() * this.parts.length)];
	    },
	    rand: function rand(min, max) {
	      return Math.random() * (max - min) + min;
	    },
	    moveMouse: function moveMouse(e) {
	      this.mouseX = e.x;
	      this.mouseY = e.y;
	    },
	    mouseDown: function mouseDown(e) {
	      this.repelDist = this.repelDist + 50;
	    },
	    mouseUp: function mouseUp(e) {
	      this.repelDist = this.repelDist - 50;
	    },
	    mouseLeave: function mouseLeave(e) {
	      this.mouseX = this.canvas.width / 2;
	      this.mouseY = this.canvas.height / 3;
	    },
	    init: function init() {
	      if (!document.querySelector(".bmv-reflection .bubbles")) {
	        setTimeout(this.init, 30);
	      } else {
	        var w = window,
	            d = document,
	            e = d.documentElement,
	            g = d.getElementsByTagName('body')[0],
	            x = w.innerWidth || e.clientWidth || g.clientWidth,
	            y = w.innerHeight || e.clientHeight || g.clientHeight;
	        this.canvas = this.$el;
	        this.ctx = this.canvas.getContext('2d');
	        this.canvas.width = x;
	        this.canvas.height = y;
	        this.ctx.fillStyle = "white";
	        this.ctx.fillRect(0, 0, x, y);
	        this.canvas2 = document.querySelector('.bmv-reflection .bubbles');
	        this.ctx2 = this.canvas2.getContext('2d');
	        this.canvas2.width = x;
	        this.canvas2.height = y;
	        this.radius = this.repelDist = Math.max(y, x) / 1.5;
	        this.createParticleTemplates();
	        this.mouseX = x / 2;
	        this.mouseY = y / 3;
	        for (var n = 0; n < this.numParticles; n++) {
	
	          var neg = 1;
	          var neg2 = 2;
	          if (this.rand(0, 1) > .5) neg = -1;
	          if (this.rand(0, 1) > .5) neg2 = -2;
	          this.particles[n] = {
	            radius: this.radius,
	            drawn: this.parts[Math.floor(Math.random() * this.parts.length)],
	            xPos: this.rand(0, x) - this.radius,
	            yPos: this.rand(0, y) - this.radius,
	            xVel: this.rand(this.minSpeed, this.maxSpeed) * neg,
	            yVel: this.rand(this.minSpeed, this.maxSpeed) * neg2
	          };
	        }
	
	        this.canvas.addEventListener("mousemove", this.moveMouse, false);
	        this.canvas.onmousedown = this.mouseDown;
	        this.canvas.onmouseup = this.mouseUp;
	        this.canvas.onmouseleave = this.mouseLeave;
	        requestInterval(this.drawParticles, 1000 / 60);
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (enabled) {
	      this.init();
	    }
	  }
	};
	
	var requestInterval = function requestInterval(fn, delay) {
	  var requestAnimFrame = function () {
	    return window.requestAnimationFrame || function (callback, element) {
	      window.setTimeout(callback, 1000 / 60);
	    };
	  }(),
	      start = new Date().getTime(),
	      handle = {};
	  function loop() {
	    handle.value = requestAnimFrame(loop);
	    var current = new Date().getTime(),
	        delta = current - start;
	    if (delta >= delay) {
	      fn.call();
	      start = new Date().getTime();
	    }
	  }
	  handle.value = requestAnimFrame(loop);
	  return handle;
	};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'bmv-bar-chart',
	  props: ['client', 'chartdata', 'initialmonth', 'monthlabel', 'finder', 'left'],
	  data: function data() {
	    return {
	      inview: false
	    };
	  },
	  methods: {
	    addInview: function addInview() {
	      this.showInview();
	    },
	    removeInview: function removeInview() {
	      this.hideInview();
	    },
	    showInview: function showInview() {
	      this.inview = true;
	      var reflectedChart = document.querySelector('.bmv-reflection .' + this.finder + ' .chart');
	      if (reflectedChart) {
	        reflectedChart.classList.add('inview');
	      }
	    },
	    hideInview: function hideInview() {
	      this.inview = false;
	      var reflectedChart = document.querySelector('.bmv-reflection .' + this.finder + ' .chart');
	      if (reflectedChart) {
	        reflectedChart.classList.remove('inview');
	      }
	    },
	    barOver: function barOver(event) {
	      event.target.classList.add('hover');
	      var bars = document.querySelectorAll('.chart ul li div');
	      var n = Array.prototype.indexOf.call(bars, event.target);
	      bars[bars.length / 2 + n].classList.add('hover');
	    },
	    barOff: function barOff(event) {
	      event.target.classList.remove('hover');
	      var bars = document.querySelectorAll('.chart ul li div');
	      var n = Array.prototype.indexOf.call(bars, event.target);
	      bars[bars.length / 2 + n].classList.remove('hover');
	    },
	    getPct: function getPct(value) {
	      return value / (Math.max.apply(Math, this.chartdata) / 100) + '%';
	    },
	    getWidth: function getWidth() {
	      return 100 / this.chartdata.length + '%';
	    },
	    getColor: function getColor(value) {
	      if (value <= this.initialmonth) {
	        return 'before';
	      } else {
	        return 'after';
	      }
	    },
	    formatMonth: function formatMonth(value, pct) {
	      if (value <= this.initialmonth) {
	        return 'Before Visible SEO Campaign';
	      } else {
	        return this.monthlabel + ' ' + (value - this.initialmonth) + ': Up ' + Math.round(pct - 100) + '%';
	      }
	    }
	  }
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _clientfilter = __webpack_require__(104);
	
	var _clientfilter2 = _interopRequireDefault(_clientfilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'clientlist',
	  props: ['index', 'name', 'logo', 'services'],
	  components: {
	    clientfilter: _clientfilter2.default
	  },
	  methods: {
	    resetBoxes: function resetBoxes() {
	      if (!this.isMobile) {
	        var boxes = document.querySelectorAll(".bmv-reflective .client");
	        Array.prototype.forEach.call(boxes, function (el, i) {
	          var rect = el.getBoundingClientRect();
	          var x = rect.left + document.body.scrollLeft + el.offsetWidth / 2;
	          var y = rect.top + document.body.scrollTop + el.offsetHeight / 2;
	          el.setAttribute('data-x', x);
	          el.setAttribute('data-y', y);
	        });
	      }
	    },
	    boxClick: function boxClick(event) {
	      var boxes = document.querySelectorAll(".client");
	      Array.prototype.forEach.call(boxes, function (el, i) {
	        el.classList.remove('open');
	      });
	      event.target.classList.toggle('open');
	    },
	    boxHover: function boxHover(event) {
	      if (!this.isMobile) {
	        var oldboxes = document.querySelectorAll(".client.active");
	        Array.prototype.forEach.call(oldboxes, function (el, i) {
	          el.classList.remove('active');
	          el.classList.remove('open');
	        });
	        event.target.classList.add('active');
	        var boxes = document.querySelectorAll(".bmv-reflective .client");
	        Array.prototype.forEach.call(boxes, function (el, i) {
	          var doppelgangers = document.querySelectorAll(".bmv-reflection .client");
	          var activebox = document.querySelector(".client.active");
	          var difx = el.getAttribute('data-x') - activebox.getAttribute('data-x');
	          var dify = el.getAttribute('data-y') - activebox.getAttribute('data-y');
	          var dif = Math.sqrt(difx * difx + dify * dify);
	          var amp = 20 - dif / 50;
	          var mycss = '';
	          if (dif === 0) {
	            doppelgangers[i].classList.add('active');
	            mycss = 'perspective(100px) rotateX(0deg) rotateY(0deg) scale(1)';
	          } else {
	            mycss = 'perspective(100px) rotateX(' + Math.round(dify / dif * amp) + 'deg) rotateY(' + (0 - Math.round(difx / dif * amp)) + 'deg) scale(0.8)';
	          }
	          el.style.transform = mycss;
	          doppelgangers[i].style.transform = mycss;
	        });
	      }
	    },
	    boxOff: function boxOff(event) {
	      if (!this.isMobile) {
	        event.target.classList.remove('active');
	        event.target.classList.remove('open');
	        var boxes = document.querySelectorAll(".client");
	        Array.prototype.forEach.call(boxes, function (el, i) {
	          el.style.transform = "perspective(100px) rotateX(0deg) rotateY(0deg) scale(0.8)";
	          el.classList.remove('active');
	          el.classList.remove('open');
	        });
	      }
	    },
	    loadedClient: function loadedClient(event) {
	      requestAnimationFrame(function () {
	        var mirror = document.querySelector('.bmv-reflection .clients div[data-n="' + event.$el.getAttribute('data-n') + '"]');
	        if (mirror) {
	          mirror.innerHTML = event.$el.innerHTML;
	        }
	      });
	    },
	    reflectThis: function reflectThis() {
	      document.querySelector(".bmv-reflection .clients").innerHTML = document.querySelector(".bmv-reflective .clients").innerHTML;
	      this.resetBoxes();
	    },
	
	    sortByProperty: function sortByProperty(p) {
	      return function (a, b) {
	        return a[p].localeCompare(b[p]);
	      };
	    }
	  },
	  mounted: function mounted() {
	    var isMobileD = {
	      android: function android() {
	        return navigator.userAgent.match(/Android/i);
	      },
	      blackberry: function blackberry() {
	        return navigator.userAgent.match(/BlackBerry/i);
	      },
	      ios: function ios() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	      },
	      opera: function opera() {
	        return navigator.userAgent.match(/Opera Mini/i);
	      },
	      windows: function windows() {
	        return navigator.userAgent.match(/IEMobile/i);
	      },
	      any: function any() {
	        return isMobileD.android() || isMobileD.blackberry() || isMobileD.ios() || isMobileD.opera() || isMobileD.windows();
	      }
	    };
	    this.isMobile = isMobileD.any();
	
	    window.addEventListener('resize', this.resetBoxes, false);
	
	    this.resetBoxes();
	  },
	
	  data: function data() {
	    return {
	      isMobile: false,
	      clients: [{
	        "logo": "a8.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": true,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Analytics8"
	      }, {
	        "logo": "azar.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Azar Nut Company"
	      }, {
	        "logo": "bvf.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Bay Valley Foods"
	      }, {
	        "logo": "bosch.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Microsite Development",
	        "name": "Bosch"
	      }, {
	        "logo": "carcollection.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "Car Collection"
	      }, {
	        "logo": "pro.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "Chicago Pro Speakers"
	      }, {
	        "logo": "csn.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": true,
	        "code": true,
	        "design": true,
	        "description": "SEO, Web Design, Development & Micro-site Development",
	        "name": "Corporate Suites Network"
	      }, {
	        "logo": "cssi.jpg",
	        "dev": false,
	        "agency": true,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Partner Agency",
	        "name": "CSSI Marketing + Culinary"
	      }, {
	        "logo": "cw.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": true,
	        "design": true,
	        "description": "CFO Roundtable Web Design & Development",
	        "name": "CW CFO Roundtable"
	      }, {
	        "logo": "degerberg.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "Degerberg"
	      }, {
	        "logo": "diamond.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Diamond Marketing Solutions"
	      }, {
	        "logo": "directions.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Directions Training"
	      }, {
	        "logo": "fitlp.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "FIT Lincoln Park"
	      }, {
	        "logo": "goodcheap.jpg",
	        "dev": true,
	        "agency": true,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Good Cheap Video"
	      }, {
	        "logo": "grubhub.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": false,
	        "code": true,
	        "design": true,
	        "description": "Banner Ad Development",
	        "name": "GrubHub"
	      }, {
	        "logo": "hard.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": true,
	        "design": false,
	        "description": "Website Development",
	        "name": "Hard Pressed"
	      }, {
	        "logo": "hozell.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "Hozell"
	      }, {
	        "logo": "ia.jpg",
	        "dev": true,
	        "agency": true,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Website Development",
	        "name": "IA Collaborative"
	      }, {
	        "logo": "IMedge.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "IM edge"
	      }, {
	        "logo": "jacobs.jpg",
	        "dev": false,
	        "agency": true,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Jacobs Agency"
	      }, {
	        "logo": "jet.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "Jet Collection"
	      }, {
	        "logo": "jones.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Jones Dairy Farm"
	      }, {
	        "logo": "kd.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": false,
	        "code": true,
	        "design": false,
	        "description": "Custom Programming",
	        "name": "KD Mailing"
	      }, {
	        "logo": "KillerSpin.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Killerspin"
	      }, {
	        "logo": "kingsbury.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": true,
	        "design": false,
	        "description": "SEO & Custom Programming",
	        "name": "Kingsbury Plaza"
	      }, {
	        "logo": "ksn.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Development",
	        "name": "Kovitz Shifrin Nesbit"
	      }, {
	        "logo": "lpm.jpg",
	        "dev": true,
	        "agency": true,
	        "seo": false,
	        "code": true,
	        "design": true,
	        "description": "Web Development",
	        "name": "Lisa P. Maxwell"
	      }, {
	        "logo": "lurie.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Lurie Children's Hospital"
	      }, {
	        "logo": "mccanns.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "McCann's Irish Oatmeal"
	      }, {
	        "logo": "mcdevitt.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": true,
	        "description": "Web Development & SEO",
	        "name": "McDevitt"
	      }, {
	        "logo": "mcdh.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "McDonald Hopkins"
	      }, {
	        "logo": "mhdesign.jpg",
	        "dev": true,
	        "agency": true,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Mike Hough Design"
	      }, {
	        "logo": "namewell.jpg",
	        "dev": false,
	        "agency": true,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Namewell"
	      }, {
	        "logo": "natures.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Development",
	        "name": "Nature's Own Water Care"
	      }, {
	        "logo": "norkol.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": true,
	        "description": "Web Design, Development & SEO",
	        "name": "Norkol"
	      }, {
	        "logo": "prf.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Paul Ruby Foundation"
	      }, {
	        "logo": "phillips.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": true,
	        "description": "Web Design, Development, & SEO",
	        "name": "Phillips Martin"
	      }, {
	        "logo": "powerplanter.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": false,
	        "code": true,
	        "design": false,
	        "description": "Programming",
	        "name": "Power Planter"
	      }, {
	        "logo": "primo.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Primo Tees"
	      }, {
	        "logo": "pug.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "Pug Story"
	      }, {
	        "logo": "redmoby.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Development",
	        "name": "Red Moby"
	      }, {
	        "logo": "reina.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": true,
	        "design": false,
	        "description": "Web Development & Custom Programming",
	        "name": "Reina Imaging"
	      }, {
	        "logo": "rightpoint.jpg",
	        "dev": false,
	        "agency": true,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Rightpoint"
	      }, {
	        "logo": "rsi.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "RSi"
	      }, {
	        "logo": "sacp.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "Send a care package"
	      }, {
	        "logo": "situ8.jpg",
	        "dev": false,
	        "agency": true,
	        "seo": true,
	        "code": true,
	        "design": false,
	        "description": "SEO & Site Re-development",
	        "name": "Situ8"
	      }, {
	        "logo": "stitchtopia.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Stitchtopia"
	      }, {
	        "logo": "strongsuit.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": true,
	        "description": "Web Design, Development, & SEO",
	        "name": "Strongsuit"
	      }, {
	        "logo": "techimage.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": true,
	        "code": true,
	        "design": true,
	        "description": "Web Design, Development & SEO",
	        "name": "Tech Image"
	      }, {
	        "logo": "habitat.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": true,
	        "code": true,
	        "design": true,
	        "description": "Microsite Design, Development & SEO",
	        "name": "The Habitat Company"
	      }, {
	        "logo": "iroquois.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "The Iroquois Club"
	      }, {
	        "logo": "topdriver.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Top Driver"
	      }, {
	        "logo": "trifecta.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Trifecta"
	      }, {
	        "logo": "vi.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "Vi"
	      }, {
	        "logo": "wlf.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Search Engine Optimization",
	        "name": "West Liberty Foods"
	      }, {
	        "logo": "wholesalep.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": true,
	        "description": "Web Design & Development",
	        "name": "Wholesale Point"
	      }, {
	        "logo": "wrapz.jpg",
	        "dev": false,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Updates",
	        "name": "Wrapz"
	      }, {
	        "logo": "york.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": true,
	        "code": false,
	        "design": true,
	        "description": "Web Design, Development & SEO",
	        "name": "York Terrace"
	      }, {
	        "logo": "young.jpg",
	        "dev": true,
	        "agency": false,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Young Center"
	      }, {
	        "logo": "zimmer.jpg",
	        "dev": true,
	        "agency": true,
	        "seo": false,
	        "code": false,
	        "design": false,
	        "description": "Web Development",
	        "name": "Zimmer Design"
	      }]
	
	    };
	  }
	};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Form = __webpack_require__(101);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'contact',
	  components: {
	    bmvForm: _Form2.default
	  }
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(50);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'bmv-form',
	  data: function data() {
	    return { email: ''
	    };
	  },
	  mounted: function mounted() {
	    this.email = '';
	    var form = document.querySelector('.contact_form');
	
	    form.onsubmit = function (e) {
	      e.preventDefault();
	      form.classList.add('submitting');
	
	      var data = {};
	      for (var i = 0, ii = form.length; i < ii; ++i) {
	        var input = form[i];
	        if (input.name) {
	          data[input.name] = input.value;
	        }
	      }
	
	      var xhr = new XMLHttpRequest();
	      xhr.open(form.method, form.action, true);
	      xhr.setRequestHeader('Accept', 'application/json; charset=utf-8');
	      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
	
	      xhr.send((0, _stringify2.default)(data));
	
	      xhr.onloadend = function (response) {
	        form.classList.remove('submitting');
	        form.classList.add('submitted');
	        if (response.target.status === 0) {
	          document.querySelector('.failure').classList.add('on');
	        } else if (response.target.status === 400) {
	          document.querySelector('.failure').classList.add('on');
	        } else if (response.target.status === 200) {
	          document.querySelector('.successful').classList.add('on');
	        }
	      };
	    };
	  }
	};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Galleryitem = __webpack_require__(103);
	
	var _Galleryitem2 = _interopRequireDefault(_Galleryitem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'gallery',
	  components: {
	    galleryItem: _Galleryitem2.default
	  }
	};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var animations = [];
	var loadedImages = [];
	
	exports.default = {
	  name: 'gallery-item',
	  props: ['mainurl', 'mobileurl', 'name', 'designer', 'n'],
	  methods: {
	    animate: function animate() {},
	    beginAnimation: function beginAnimation(component) {
	      requestAnimationFrame(function () {
	        var n = component.$el.getAttribute('data-n');
	        var mirror = document.querySelector('.bmv-reflection .gallery div[data-n="' + n + '"]');
	        if (mirror) {
	          mirror.innerHTML = component.$el.innerHTML;
	        }
	        var monitorSize = document.querySelector('.monitor-inner .screen').clientHeight;
	        if (n.indexOf('p') > -1) {
	          monitorSize = document.querySelector('.phone-inner .screen').clientHeight;
	        }
	        var img = document.querySelector('.bmv-reflective .gallery div[data-n="' + n + '"] img');
	
	        var imgs = document.querySelectorAll('.gallery div[data-n="' + n + '"] img');
	        loadedImages.push(component);
	        setTimeout(function () {
	          imgs.forEach(function (element) {
	            var mDistance = element.clientHeight - monitorSize;
	            if (mDistance > 1) {
	              animations.push(element.animate([{ transform: 'translateY(0px)', easing: 'ease-in-out' }, { transform: 'translateY(-' + mDistance + 'px)', easing: 'ease-out' }], {
	                duration: 8000,
	                iterations: Infinity,
	                direction: "alternate",
	                delay: 0
	              }));
	            }
	          });
	        }, 2000);
	      });
	    },
	    restartAnimations: function restartAnimations() {
	      var _this = this;
	
	      var tmpImages = loadedImages;
	      loadedImages = [];
	
	      tmpImages.forEach(function (el) {
	        _this.beginAnimation(el);
	      });
	    },
	    cancelAnimations: function cancelAnimations() {
	      animations.forEach(function (element) {
	        element.cancel();
	      });
	      animations = [];
	      requestAnimationFrame(this.restartAnimations);
	    }
	  },
	  mounted: function mounted() {
	    window.addEventListener('resize', this.cancelAnimations);
	  }
	};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'clientfilter',
	  data: function data() {
	    return { clients: {}
	    };
	  },
	  methods: {
	    filterClients: function filterClients(e) {
	      var _this = this;
	
	      var boxes = document.querySelectorAll(".bmv-reflective .clients .client");
	      var refboxes = document.querySelectorAll(".bmv-reflection .clients .client");
	      boxes.forEach(function (el, i) {
	        _this.rafTimeout(function () {
	          if (e.target.value === "all" || el.classList.contains(e.target.value)) {
	            el.classList.remove('hide');
	            refboxes[i].classList.remove('hide');
	          } else {
	            el.classList.add('hide');
	            refboxes[i].classList.add('hide');
	          }
	        }, 20 * i);
	      });
	    },
	    rafTimeout: function rafTimeout(fn, delay) {
	      if (!window.requestAnimationFrame && !window.webkitRequestAnimationFrame && !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) && !window.oRequestAnimationFrame && !window.msRequestAnimationFrame) {
	        return window.setTimeout(fn, delay);
	      }
	      var start = new Date().getTime();
	      var handle = new Object();
	
	      function loop() {
	        var current = new Date().getTime();
	        var delta = current - start;
	        delta >= delay ? fn.call() : handle.value = window.requestAnimationFrame(loop);
	      }
	      handle.value = window.requestAnimationFrame(loop);
	      return handle;
	    }
	  }
	};

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(91)
	
	/* script */
	__vue_exports__ = __webpack_require__(39)
	
	/* template */
	var __vue_template__ = __webpack_require__(114)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(87)
	
	/* script */
	__vue_exports__ = __webpack_require__(40)
	
	/* template */
	var __vue_template__ = __webpack_require__(110)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-40ff7421"
	
	module.exports = __vue_exports__


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(86)
	
	/* script */
	__vue_exports__ = __webpack_require__(41)
	
	/* template */
	var __vue_template__ = __webpack_require__(109)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2e7981fb"
	
	module.exports = __vue_exports__


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(85)
	
	/* script */
	__vue_exports__ = __webpack_require__(42)
	
	/* template */
	var __vue_template__ = __webpack_require__(108)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-21ccd01c"
	
	module.exports = __vue_exports__


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(88)
	
	/* script */
	__vue_exports__ = __webpack_require__(43)
	
	/* template */
	var __vue_template__ = __webpack_require__(111)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-63ffa832"
	
	module.exports = __vue_exports__


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(82)
	
	/* script */
	__vue_exports__ = __webpack_require__(44)
	
	/* template */
	var __vue_template__ = __webpack_require__(105)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-016fc434"
	
	module.exports = __vue_exports__


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(84)
	
	/* script */
	__vue_exports__ = __webpack_require__(45)
	
	/* template */
	var __vue_template__ = __webpack_require__(107)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2169dd40"
	
	module.exports = __vue_exports__


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(90)
	
	/* script */
	__vue_exports__ = __webpack_require__(46)
	
	/* template */
	var __vue_template__ = __webpack_require__(113)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ee42e66"
	
	module.exports = __vue_exports__


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(89)
	
	/* script */
	__vue_exports__ = __webpack_require__(47)
	
	/* template */
	var __vue_template__ = __webpack_require__(112)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-670d50f9"
	
	module.exports = __vue_exports__


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(83)
	
	/* script */
	__vue_exports__ = __webpack_require__(48)
	
	/* template */
	var __vue_template__ = __webpack_require__(106)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-14608002"
	
	module.exports = __vue_exports__


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "is-4 column"
	  }, [_c('bmv-form')], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "is-4 is-offset-2 column"
	  }, [_c('div', {
	    staticClass: "contactbox"
	  }, [_c('p', [_c('b', [_vm._v("Be More Visible, Inc.")]), _c('br'), _vm._v("\n      3022 N. Clifton Ave. #1"), _c('br'), _vm._v("\n      Chicago, IL 60657")]), _vm._v(" "), _c('p', [_vm._v("312-259-6410")]), _vm._v(" "), _c('p', [_c('a', {
	    attrs: {
	      "href": "mailto:info@bemorevisible.com"
	    }
	  }, [_vm._v("info@bemorevisible.com")])])])])
	}]}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cfilter is-hidden-mobile"
	  }, [_c('div', {
	    staticClass: "cfilter_inner"
	  }, [_c('input', {
	    attrs: {
	      "id": "tab-1",
	      "name": "buttons",
	      "type": "radio",
	      "value": "all"
	    },
	    domProps: {
	      "checked": true
	    },
	    on: {
	      "click": _vm.filterClients
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "tab-1"
	    }
	  }, [_c('div', {
	    staticClass: "cfilter_inner__tab"
	  }, [_c('h2', [_c('icon', {
	    staticClass: "fa fa-eye",
	    attrs: {
	      "name": "eye"
	    }
	  }), _vm._v("\n        All Clients\n        ")], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('input', {
	    attrs: {
	      "id": "tab-2",
	      "name": "buttons",
	      "type": "radio",
	      "value": "agency"
	    },
	    on: {
	      "click": _vm.filterClients
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "tab-2"
	    }
	  }, [_c('div', {
	    staticClass: "cfilter_inner__tab"
	  }, [_c('h2', [_c('icon', {
	    staticClass: "fa fa-institution",
	    attrs: {
	      "name": "institution"
	    }
	  }), _vm._v("\n          Agencies\n        ")], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('input', {
	    attrs: {
	      "id": "tab-3",
	      "name": "buttons",
	      "type": "radio",
	      "value": "seo"
	    },
	    on: {
	      "click": _vm.filterClients
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "tab-3"
	    }
	  }, [_c('div', {
	    staticClass: "cfilter_inner__tab"
	  }, [_c('h2', [_c('icon', {
	    staticClass: "fa fa-bar-chart",
	    attrs: {
	      "name": "bar-chart"
	    }
	  }), _vm._v("\n          SEO\n        ")], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('input', {
	    attrs: {
	      "id": "tab-4",
	      "name": "buttons",
	      "type": "radio",
	      "value": "dev"
	    },
	    on: {
	      "click": _vm.filterClients
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "tab-4"
	    }
	  }, [_c('div', {
	    staticClass: "cfilter_inner__tab"
	  }, [_c('h2', [_c('icon', {
	    staticClass: "fa fa-desktop",
	    attrs: {
	      "name": "wordpress"
	    }
	  }), _vm._v("\n          Web Development\n        ")], 1), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('input', {
	    attrs: {
	      "id": "tab-5",
	      "name": "buttons",
	      "type": "radio",
	      "value": "code"
	    },
	    on: {
	      "click": _vm.filterClients
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "tab-5"
	    }
	  }, [_c('div', {
	    staticClass: "cfilter_inner__tab"
	  }, [_c('h2', [_c('icon', {
	    staticClass: "fa fa-desktop",
	    attrs: {
	      "name": "code"
	    }
	  }), _vm._v("\n          Programming\n        ")], 1), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('input', {
	    attrs: {
	      "id": "tab-6",
	      "name": "buttons",
	      "type": "radio",
	      "value": "design"
	    },
	    on: {
	      "click": _vm.filterClients
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "tab-6"
	    }
	  }, [_c('div', {
	    staticClass: "cfilter_inner__tab"
	  }, [_c('h2', [_c('icon', {
	    staticClass: "fa fa-desktop",
	    attrs: {
	      "name": "desktop"
	    }
	  }), _vm._v("\n          Web Design\n        ")], 1), _vm._v(" "), _vm._m(5)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "details"
	  }, [_c('p', [_vm._v("Visible is proud to have worked with a plethora of clients on projects including web development, SEO, and much more.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "details"
	  }, [_c('p', [_vm._v("Visible has built and maintained strong relationships with some of the top agencies in Chicago and around the nation.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "details"
	  }, [_c('p', [_vm._v("Visible has worked with countless clients and partners to improve their search traffic. ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "details"
	  }, [_c('p', [_vm._v("Visible has built sites from the ground up for hundreds of clients.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "details"
	  }, [_c('p', [_vm._v("Visible provides custom programming solutions on both the front-end and back-end, as well as debugging.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "details"
	  }, [_c('p', [_vm._v("Visible either designs or works with top designers to provide an incredible user experience for our client's sites.")])])
	}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bmvform"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h1', [_vm._v("Contact Us")]), _vm._v(" "), _c('form', {
	    staticClass: "contact_form",
	    attrs: {
	      "action": "https://formspree.io/info@bemorevisible.com",
	      "method": "POST"
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "field"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    class: {
	      notempty: _vm.email != ''
	    },
	    attrs: {
	      "type": "email",
	      "name": "_replyto",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Email")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
	    staticClass: "submit"
	  }, [_c('div', {
	    staticClass: "submit--text"
	  }, [_vm._v("Submit")]), _c('div', {
	    staticClass: "working"
	  }, [_c('icon', {
	    staticClass: "fa fa-spinner fa-2x",
	    attrs: {
	      "name": "spinner",
	      "scale": "2"
	    }
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "successful"
	  }, [_c('p', [_c('b', [_vm._v("Thank you for contacting Visible.")]), _c('br'), _vm._v("We'll be in touch soon.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "failure"
	  }, [_c('p', [_c('b', [_vm._v("ERROR: Oops! This is embarassing")]), _c('br'), _vm._v("Something went wrong with your submission.  Please email us at "), _c('a', {
	    attrs: {
	      "href": "mailto:info@bemorevisible.com"
	    }
	  }, [_vm._v("info@bemorevisible.com")]), _vm._v(".")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "field"
	  }, [_c('input', {
	    attrs: {
	      "type": "text",
	      "name": "name",
	      "required": ""
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Name")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "field"
	  }, [_c('textarea', {
	    attrs: {
	      "name": "message",
	      "required": ""
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Message")])])
	}]}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hero-body",
	    class: [_vm.finder]
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "columns chartcontainer is-gapless"
	  }, [_c('div', {
	    staticClass: "column is-4"
	  }, [_c('h1', [_vm._v(_vm._s(this.client))]), _vm._v(" "), _c('h2', [_vm._v("Search Engine Optimization Results")]), _vm._v(" "), _c('div', {
	    staticClass: "moreinfo"
	  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "column is-8"
	  }, [_c('div', {
	    staticClass: "chart",
	    class: [{
	      'inview': _vm.inview
	    }]
	  }, [_c('v-waypoint', {
	    staticClass: "chart--waypoint",
	    on: {
	      "waypoint-in": _vm.addInview,
	      "waypoint-out": _vm.removeInview
	    }
	  }), _vm._v(" "), _c('ul', _vm._l((_vm.chartdata), function(chartdataset, index) {
	    return _c('li', {
	      key: index,
	      style: ({
	        width: _vm.getWidth()
	      })
	    }, [_c('div', {
	      key: index,
	      class: _vm.getColor(index),
	      style: ({
	        height: _vm.getPct(chartdataset)
	      }),
	      attrs: {
	        "title": _vm.formatMonth(index, chartdataset)
	      },
	      on: {
	        "mouseover": _vm.barOver,
	        "mouseleave": _vm.barOff
	      }
	    })])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "legend columns"
	  }, [(this.initialmonth > -1) ? _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "before"
	  }), _vm._v(" "), _c('b', [_vm._v("Before Visible SEO Campaign")])]) : _vm._e(), _vm._v(" "), _vm._m(0)])], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "after"
	  }), _vm._v(" "), _c('b', [_vm._v("During Visible SEO Campaign")])])
	}]}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('canvas', {
	    staticClass: "bubbles"
	  })
	},staticRenderFns: []}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-full"
	  }, [_c('h1', [_vm._v("Building Your Site Right the First Time")]), _vm._v(" "), _c('p', {
	    staticClass: "subhead"
	  }, [_vm._v("Today, more than ever, success in business starts with online visibility. Your business needs to be easy to find on the web. We can help. Making you visible online is our business.")]), _vm._v(" "), _c('p', {
	    staticClass: "subhead"
	  }, [_vm._v("A great deal of our work involves re-developing web sites that were created by web companies who didn't develop with an understanding of SEO. That's why choosing Visible to build your web site is a "), _c('em', [_vm._v("smart business decision")]), _vm._v(". Since 2008, Visible has developed hundreds of beautiful and functional web sites that adhere to "), _c('em', [_vm._v("SEO best practices")]), _vm._v(".")]), _vm._v(" "), _c('h1', [_vm._v("Core Capabilities")]), _vm._v(" "), _c('div', {
	    staticClass: "columns core"
	  }, [_c('div', {
	    staticClass: "column is-4"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/development.jpg",
	      "alt": "Full Stack Web Development"
	    }
	  }), _vm._v(" "), _c('h2', [_vm._v("Full Stack Web Development")]), _vm._v(" "), _c('p', [_vm._v("Visible provides top notch web development from front-end javascript, styling, and UI/UX to back-end development, CMS management, and database design.")])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-4"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/seo.jpg",
	      "alt": "Search Engine Optimization"
	    }
	  }), _vm._v(" "), _c('h2', [_vm._v("Search Engine Optimization (SEO)")]), _vm._v(" "), _c('p', [_vm._v("Visible provides the full gamut of SEO support.  Whether it be reviewing analytics, providing key phrase research, or performing technical audits, Visible has the experience to maximize your site's search engine traffic.")])]), _vm._v(" "), _c('div', {
	    staticClass: "column is-4"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/design.jpg",
	      "alt": "Web Design"
	    }
	  }), _vm._v(" "), _c('h2', [_vm._v("Web Design")]), _vm._v(" "), _c('p', [_vm._v("Visible partners with industry leaders in web design to provide an exceptional experience to site visitors.  Our sites are designed to be responsive, with desktop, laptop, and mobile devices in mind.")])])])])]), _vm._v(" "), _c('h1', [_vm._v("Technologies")]), _vm._v(" "), _c('div', {
	    staticClass: "columns technologies"
	  }, [_c('div', {
	    staticClass: "is-half column"
	  }, [_c('h2', [_vm._v("Languages")]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/js.png",
	      "alt": "JavaScript"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/php.png",
	      "alt": "PHP"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/aspnet.png",
	      "alt": "ASP.NET"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/html5.png",
	      "alt": "HTML5"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/css3.png",
	      "alt": "CSS3"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/sass.png",
	      "alt": "Sass"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/less.png",
	      "alt": "less"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "is-half column"
	  }, [_c('h2', [_vm._v("Frameworks / Libraries")]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/jquery.png",
	      "alt": "jQuery"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/vue.png",
	      "alt": "Vue"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/react.png",
	      "alt": "React"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/angular.png",
	      "alt": "Angular"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/foundation.png",
	      "alt": "Foundation"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/bootstrap.png",
	      "alt": "Bootstrap"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/bulma.png",
	      "alt": "Bulma"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "columns technologies"
	  }, [_c('div', {
	    staticClass: "is-half column"
	  }, [_c('h2', [_vm._v("Content Management Systems & Databases")]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/wp.png",
	      "alt": "WordPress"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/drupal.png",
	      "alt": "Drupal"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/magento.png",
	      "alt": "Magento"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/mssql.png",
	      "alt": "Microsoft SQL Server"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/mysql.png",
	      "alt": "MySQL"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/mongodb.png",
	      "alt": "MongoDB"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "is-half column"
	  }, [_c('h2', [_vm._v("Software & Build Tools")]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/adobeps.png",
	      "alt": "Adobe Photoshop"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/sublime.png",
	      "alt": "Sublime Text"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/vscode.png",
	      "alt": "Visual Studio Code"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/git.png",
	      "alt": "Git"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/npm.png",
	      "alt": "NPM"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/gulp.png",
	      "alt": "Gulp"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/webpack.png",
	      "alt": "Webpack"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tech"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/tech/babel.png",
	      "alt": "Babel"
	    }
	  })])])])])
	}]}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column is-one-quarter  cfholder"
	  }, [_c('clientfilter')], 1), _vm._v(" "), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "columns is-multiline is-gapless is-mobile clientcontainer",
	    on: {
	      "mouseleave": _vm.boxOff
	    }
	  }, _vm._l((this.clients), function(client, index) {
	    return _c('div', {
	      staticClass: "column is-narrow"
	    }, [_c('div', {
	      staticClass: "client",
	      class: {
	        dev: client.dev, seo: client.seo, code: client.code, design: client.design, agency: client.agency
	      },
	      on: {
	        "mouseover": _vm.boxHover,
	        "click": _vm.boxClick
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": './static/clients/' + client.logo,
	        "alt": client.name
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "details"
	    }, [_c('b', [_vm._v(_vm._s(client.name))]), _c('br'), _vm._v(_vm._s(client.description))])])])
	  }))])])
	},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "is-full column"
	  }, [_c('h1', [_vm._v(_vm._s(this.name))]), _vm._v(" "), _c('h2', [_vm._v("Design by: " + _vm._s(this.designer))]), _vm._v(" "), _c('div', {
	    staticClass: "gallery-item",
	    attrs: {
	      "data-n": this.n
	    }
	  }, [(_vm.mobileurl !== '') ? _c('div', {
	    staticClass: "phone-container"
	  }, [_c('div', {
	    staticClass: "phone"
	  }, [_c('div', {
	    staticClass: "phone-inner"
	  }, [_c('div', {
	    staticClass: "screen"
	  }, [_c('lazy-component', {
	    attrs: {
	      "data-n": this.n + 'p'
	    },
	    on: {
	      "show": _vm.beginAnimation
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.mobileurl,
	      "alt": this.name + ' Mobile'
	    }
	  }), _vm._v(" "), _c('icon', {
	    attrs: {
	      "name": "spinner",
	      "scale": "3"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('img', {
	    staticClass: "phone-img",
	    attrs: {
	      "src": "static/mobile.png",
	      "alt": "Mobile View"
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "monitor-container"
	  }, [_c('div', {
	    staticClass: "monitor"
	  }, [_c('div', {
	    staticClass: "monitor-inner"
	  }, [_c('div', {
	    staticClass: "screen"
	  }, [_c('lazy-component', {
	    attrs: {
	      "data-n": this.n + 'm'
	    },
	    on: {
	      "show": _vm.beginAnimation
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.mainurl,
	      "alt": this.name + ' Site'
	    }
	  }), _vm._v(" "), _c('icon', {
	    attrs: {
	      "name": "spinner",
	      "scale": "3"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('img', {
	    staticClass: "monitor-img",
	    attrs: {
	      "src": "static/desktop.png",
	      "alt": "Desktop View"
	    }
	  })])])])])])
	},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns is-multiline"
	  }, [_c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/csn-full.jpg",
	      "mobileurl": "static/gallery/csn-mobile.jpg",
	      "name": "Corporate Suites Network",
	      "designer": "Visible",
	      "n": "1"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/reina-full.jpg",
	      "mobileurl": "static/gallery/reina-mobile.jpg",
	      "name": "Reina Imaging",
	      "designer": "Zimmer-Design",
	      "n": "2"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/trifecta-full.jpg",
	      "mobileurl": "static/gallery/trifecta-mobile.jpg",
	      "name": "Trifecta Sauces",
	      "designer": "Zimmer-Design",
	      "n": "3"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/wlf-full.jpg",
	      "mobileurl": "static/gallery/wlf-mobile.jpg",
	      "name": "West Liberty Foods",
	      "designer": "CSSI",
	      "n": "4"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/azar-full.jpg",
	      "mobileurl": "static/gallery/azar-mobile.jpg",
	      "name": "Azar Nut Company",
	      "designer": "CSSI",
	      "n": "5"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/iac-full.jpg",
	      "mobileurl": "",
	      "name": "IA Collaborative",
	      "designer": "IA Collaborative",
	      "n": "6"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/bvf-full.jpg",
	      "mobileurl": "static/gallery/bvf-mobile.jpg",
	      "name": "Bay Valley Foods",
	      "designer": "CSSI",
	      "n": "7"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/pug-full.jpg",
	      "mobileurl": "",
	      "name": "Pug Story",
	      "designer": "Visible",
	      "n": "8"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/yc-full.jpg",
	      "mobileurl": "",
	      "name": "The Young Center",
	      "designer": "EPIC",
	      "n": "9"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "column is-half"
	  }, [_c('gallery-item', {
	    attrs: {
	      "mainurl": "static/gallery/red-full.jpg",
	      "mobileurl": "static/gallery/red-mobile.jpg",
	      "name": "Red Moby",
	      "designer": "Visible",
	      "n": "10"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('nav', {
	    staticClass: "bottom"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "nav"
	  }, [_c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('.home'),
	      expression: "'.home'"
	    }],
	    staticClass: "nav-item homelink"
	  }, [_c('icon', {
	    attrs: {
	      "name": "home",
	      "scale": "2"
	    }
	  })], 1), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('.about'),
	      expression: "'.about'"
	    }],
	    staticClass: "nav-item aboutlink"
	  }, [_c('icon', {
	    staticClass: "is-hidden-desktop fa-2x",
	    attrs: {
	      "name": "address-card",
	      "scale": "2"
	    }
	  }), _c('span', {
	    staticClass: "is-hidden-touch"
	  }, [_vm._v("About")])], 1), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('.clients'),
	      expression: "'.clients'"
	    }],
	    staticClass: "nav-item clientslink"
	  }, [_c('icon', {
	    staticClass: "fa fa-handshake-o is-hidden-desktop fa-2x",
	    attrs: {
	      "name": "handshake-o",
	      "scale": "2"
	    }
	  }), _c('span', {
	    staticClass: "is-hidden-touch"
	  }, [_vm._v("Clients")])], 1), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('.results'),
	      expression: "'.results'"
	    }],
	    staticClass: "nav-item resultslink"
	  }, [_c('icon', {
	    staticClass: "fa fa-bar-chart is-hidden-desktop fa-2x",
	    attrs: {
	      "name": "bar-chart",
	      "scale": "2"
	    }
	  }), _c('span', {
	    staticClass: "is-hidden-touch"
	  }, [_vm._v("Results")])], 1), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('.gallery'),
	      expression: "'.gallery'"
	    }],
	    staticClass: "nav-item gallerylink"
	  }, [_c('icon', {
	    staticClass: "fa fa-image is-hidden-desktop fa-2x",
	    attrs: {
	      "name": "image",
	      "scale": "2"
	    }
	  }), _c('span', {
	    staticClass: "is-hidden-touch"
	  }, [_vm._v("Gallery")])], 1), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('.contact'),
	      expression: "'.contact'"
	    }],
	    staticClass: "nav-item contactlink"
	  }, [_c('icon', {
	    staticClass: "fa fa-envelope-open is-hidden-desktop fa-2x",
	    attrs: {
	      "name": "envelope-open",
	      "scale": "2"
	    }
	  }), _c('span', {
	    staticClass: "is-hidden-touch"
	  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('.home'),
	      expression: "'.home'"
	    }],
	    staticClass: "nav-item is-hidden-touch"
	  }, [_c('img', {
	    staticClass: "is-pulled-right",
	    attrs: {
	      "src": __webpack_require__(93)
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "bmv-reflective"
	  }, [_c('section', {
	    staticClass: "hero bg-orange is-fullheight home"
	  }, [_c('bubbles'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('section', {
	    staticClass: "hero bg-darkblue is-fullheight about"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('about')], 1)])]), _vm._v(" "), _c('section', {
	    staticClass: "hero bg-clients clients"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "intro"
	  }, [_vm._v("Just a Few of Our Clients & Partners")]), _vm._v(" "), _c('clientlist')], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "results"
	  }, [_c('section', {
	    staticClass: "hero bg-lightblue is-fullheight"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "intro"
	  }, [_vm._v("Our Results Speak For Themselves")]), _vm._v(" "), _c('bmv-bar-chart', {
	    attrs: {
	      "client": "Analytics8",
	      "finder": "chart--A8",
	      "chartdata": [89.62108731, 82.04283361, 93.73970346, 100, 139.3739703, 128.0889621, 138.9621087, 141.6803954, 155.601318, 142.9983526, 183.1960461, 197.9406919, 197.1169687, 161.4497529, 192.9159802, 213.0971993, 237.4794069],
	      "initialmonth": 3,
	      "monthlabel": "Month",
	      "left": "1"
	    }
	  }, [_c('p', [_vm._v("Redeveloped Analytics8.com to be more accessible to search engine crawlers")]), _vm._v(" "), _c('p', [_vm._v("Immediate improvement of 39% in the first month")]), _vm._v(" "), _c('p', [_vm._v("More than doubled traffic within one year")])]), _vm._v(" "), _c('bmv-bar-chart', {
	    attrs: {
	      "client": "Vi",
	      "finder": "chart--Vi",
	      "chartdata": [100, 140.2236679, 133.4917038, 170.0899057, 168.7888312, 187.8517652, 224.4645859, 213.2811929, 209.9481032, 245.9980996, 210.715591, 214.845406, 231.9859659, 262.8170455, 225.166289, 221.8697464, 207.3020978, 255.7853958, 218.5512755, 265.9235436],
	      "initialmonth": 0,
	      "monthlabel": "Quarter",
	      "left": "0"
	    }
	  }, [_c('p', [_vm._v("Optimized ViLiving.com")]), _vm._v(" "), _c('p', [_vm._v("Immediate improvement of 40% in the first month")]), _vm._v(" "), _c('p', [_vm._v("More than doubled traffic within 6 quarters")])]), _vm._v(" "), _c('bmv-bar-chart', {
	    attrs: {
	      "client": "Corporate Suites Network",
	      "finder": "chart--CSN",
	      "chartdata": [100, 169.0023753, 167.3396675, 220.4275534, 226.128266, 242.8741093, 242.1615202, 234.0855107, 215.9144893, 209.7387173, 216.7458432, 187.1733967, 151.9002375, 225.5344418, 224.584323, 282.304038, 321.2589074, 345.1306413, 334.6793349],
	      "initialmonth": -1,
	      "monthlabel": "Month",
	      "left": "0"
	    }
	  }, [_c('p', [_vm._v("Developed and optimized HabitatCSN.com")]), _vm._v(" "), _c('p', [_vm._v("Managed SEO aspects of branding transition to CSNHousing.com")]), _vm._v(" "), _c('p', [_vm._v("Dramatically increased traffic year over year")])])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "gallery"
	  }, [_c('section', {
	    staticClass: "hero bg-orange is-fullheight"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "intro"
	  }, [_vm._v("We Make Cool Sites, See?")]), _vm._v(" "), _c('gallery')], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "contact"
	  }, [_c('section', {
	    staticClass: "hero bg-map is-fullheight"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "intro"
	  }, [_vm._v("Based In Chicago, Serving Clients Nationwide")]), _vm._v(" "), _c('contact')], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "bmv-reflection-container bottom"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home-body has-text-centered"
	  }, [_c('img', {
	    staticClass: "main-logo",
	    attrs: {
	      "src": "static/visible_logo.png",
	      "alt": "Visible"
	    }
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "headline subtitle"
	  }, [_vm._v("We make businesses more visible on the web.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flag"
	  }, [_c('h1', [_vm._v("About Visible")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flag"
	  }, [_c('h1', [_vm._v("Visible Clients")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flag"
	  }, [_c('h1', [_vm._v("Visible Results")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flag"
	  }, [_c('h1', {
	    staticClass: "right"
	  }, [_vm._v("Visible Gallery")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flag"
	  }, [_c('h1', [_vm._v("Contact Visible")])])
	}]}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    class: _vm.clazz,
	    style: (_vm.style),
	    attrs: {
	      "version": "1.1",
	      "role": _vm.label ? 'img' : 'presentation',
	      "aria-label": _vm.label,
	      "x": _vm.x,
	      "y": _vm.y,
	      "width": _vm.width,
	      "height": _vm.height,
	      "viewBox": _vm.box
	    }
	  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
	    return _c('path', _vm._b({}, 'path', path, false))
	  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
	    return _c('polygon', _vm._b({}, 'polygon', polygon, false))
	  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.icon.raw)
	    }
	  })] : _vm._e()])], 2)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.c4d9a6620cf964cdc686.js